import styles from './linkExternalAccountBody.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import colors from 'src/styles/colors.module.scss';
import LiteralsService from 'src/services/literals/LiteralsService';
import Anchor from 'src/components/atomic/atoms/anchor/Anchor';
import { BudgetPages } from 'src/components/atomic/pages/BudgetPages';
import { trackClick } from 'src/hooks/useAdobeTags';
import adobeTags from 'src/types/adobe-tags';
import { goToSettings } from 'src/services/router.service';
import Selectors from 'src/utils/selectors';
import React from 'react';
import H from 'history';

interface LinkExternalAccountBodyProps {
    history: H.History;
}

export default function LinkExternalAccountBody({ history }: LinkExternalAccountBodyProps): JSX.Element {
    return (
        <div className={styles.linkExternalAccountBody}>
            <Typography
                variant={TypographyVariants.SUBTEXT_BOLD}
                className={colors.brandStrong}
                data-cy={Selectors.SpendSmart.LINK_EXTERNAL_ACCOUNT_BODY}
            >
                {LiteralsService.getLiteral('LinkExternalAccountBody.description')}
            </Typography>
            <Anchor
                href={BudgetPages.SETTINGS}
                onClick={() => {
                    trackClick(history.location.pathname, adobeTags.Callout.LinkAccounts);
                    goToSettings(false, history);
                }}
                data-cy={Selectors.SpendSmart.LINK_EXTERNAL_ACCOUNT_ANCHOR}
            >
                {LiteralsService.getLiteral('LinkExternalAccountBody.link')}
            </Anchor>
        </div>
    );
}
